import { render, staticRenderFns } from "./ListAcademic_rank.vue?vue&type=template&id=d12f3514&scoped=true"
import script from "./ListAcademic_rank.vue?vue&type=script&lang=js"
export * from "./ListAcademic_rank.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d12f3514",
  null
  
)

export default component.exports